import type React from "react";
import type { ReactNode } from "react";
import styled from "styled-components";
import InfoButtonModal from "./InfoButtonModal";
import InputComponent from "./InputComponent";
import InputDescription from "./InputDescription";

export type LabledInputComponentProps = {
  name: string;
  label: ReactNode;
  description?: ReactNode;
  children?: React.ReactNode;
  hasError?: boolean;
  className?: string;
  reserveLabelHeight?: boolean;
};

const InputComponentLabelRow = styled.div<{ $reserveLabelHeight?: boolean }>`
  margin-bottom: ${(props) => props.theme.spacing.space8};
  display: inline-flex;
  align-items: center;
  min-height: ${(props) => (props.$reserveLabelHeight ? props.theme.spacing.space24 : "auto")};

  label {
    ${(props) => props.theme.fontStyle.componentText.dataLabel}

    em {
      text-decoration: underline;
    }
  }
`;

export default function LabeledInputComponent({
  className,
  name,
  label,
  description,
  hasError,
  reserveLabelHeight,
  children,
}: LabledInputComponentProps) {
  return (
    <div className={className}>
      <InputComponentLabelRow $reserveLabelHeight={reserveLabelHeight}>
        <label htmlFor={name}>{label}</label>
        {description ? (
          <InfoButtonModal>
            <h3>{label}</h3>
            <InputDescription description={description} />
          </InfoButtonModal>
        ) : null}
      </InputComponentLabelRow>
      <InputComponent hasError={hasError}>{children}</InputComponent>
    </div>
  );
}
